import {
  ADD_FILE,
  ADD_FILES,
  REMOVE_FILE,
  REMOVE_FILES,
  EDIT_FILE,
  RESET_FILES,
} from '../actions/filesActions';

// const initialState = [
//   {
//     type: 'folder', value: 'assets', name: 'Patrimoine', path: '/', _id: '0', fullPath: '/assets',
//   },
//   {
//     type: 'folder', value: 'planner', name: 'Démarches', path: '/', _id: '1', fullPath: '/planner',
//   },
//   {
//     type: 'folder', value: 'messenger', name: 'Messagerie posthume', path: '/', _id: '2', fullPath: '/messenger',
//   },
// ];

const initialState = [];

const removeDuplicates = (fullArray) => {
  const newArr = fullArray.reduce((res, data) => {
    if (res.findIndex(file => file.fullPath === data.fullPath) < 0) {
        res.push(data);
    }
    return res;
  }, []);
  return newArr;
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_FILE: {
      return removeDuplicates([
          action.value,
          ...state,
        ]);
    }
    case ADD_FILES: {
      return removeDuplicates([
        ...action.value,
        ...state,
      ]);
    }
    // case ADD_FILES: {
    //   return {
    //     ...state,
    //     [action.path]: removeDuplicates([
    //       ...action.value,
    //       ...state[action.path],
    //     ]),
    //   };
    // }
    case REMOVE_FILE:
      return state.filter(file => file.fullPath !== action.fullPath);
    case REMOVE_FILES:
      return state.filter((file) => {
        if (action.listFullPaths.includes(file.fullPath)) {
          return false;
        }
        let canKeep = true;
        action.listPaths.forEach((e) => {
          // startsWith path/ => all children, files and folders included
          // === path => all direct folders children
          if (file.path.startsWith(`${e}/`) || file.path === e) canKeep = false;
        });
        return canKeep;
      });
    case EDIT_FILE:
      return state.map(file => (
        file.fullPath === action.value.fullPath ? { ...file, ...action.value } : file
      ));
    case RESET_FILES:
      return initialState;
    default:
      return state;
  }
}
